import { Link } from "react-router";
import { compactNumber, elapsed, usd } from "../../lib/format";
import { issueKey } from "../../lib/tasks";
import type { TaskListItem } from "../../types";
import { LaneBadge } from "../lane-badge";
import { ColorDot, StatusBadge } from "../status-badge";
import { TimeAgo } from "../time-ago";
import { TableCell, TableRow } from "../ui/table";

const NONE = <span className="text-muted-foreground/60">—</span>;

export function TaskRow({
  task,
  station,
  onOpen,
}: {
  task: TaskListItem;
  station: { name: string; station: { color: string } } | undefined;
  onOpen: () => void;
}) {
  const key = issueKey(task);
  const { spend } = task;
  return (
    <TableRow className="group/row cursor-pointer" onClick={onOpen}>
      <TableCell className="font-mono text-[11px] text-muted-foreground">{key ?? "Manual"}</TableCell>
      <TableCell className="max-w-0 w-full">
        <div className="flex items-center gap-2">
          <Link
            to={`/tasks/${task.id}`}
            className="truncate decoration-border underline-offset-[3px] group-hover/row:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {task.title}
          </Link>
          <LaneBadge task={task} quiet className="shrink-0" />
        </div>
      </TableCell>
      <TableCell className="hidden md:table-cell">
        {station ? (
          <span className="flex items-center gap-2 whitespace-nowrap">
            <ColorDot color={station.station.color} />
            {station.name}
          </span>
        ) : (
          <span className="text-muted-foreground">{task.status === "completed" ? "Shipped" : "—"}</span>
        )}
      </TableCell>
      <TableCell>
        <StatusBadge status={task.status} />
      </TableCell>
      <TableCell className="hidden text-right text-xs whitespace-nowrap text-muted-foreground tabular-nums xl:table-cell">
        {spend.agentMs === null ? NONE : elapsed(spend.agentMs)}
      </TableCell>
      <TableCell
        className="hidden text-right text-xs text-muted-foreground tabular-nums xl:table-cell"
        title={spend.totalTokens === null ? undefined : `${spend.totalTokens.toLocaleString()} tokens`}
      >
        {spend.totalTokens === null ? NONE : compactNumber(spend.totalTokens)}
      </TableCell>
      <TableCell
        className="hidden text-right text-xs tabular-nums lg:table-cell"
        title={
          spend.unbilled > 0
            ? `${spend.unbilled} run${spend.unbilled === 1 ? "" : "s"} not billed yet`
            : undefined
        }
      >
        {spend.costUsd === null ? NONE : usd(spend.costUsd)}
      </TableCell>
      <TableCell className="hidden text-right text-xs text-muted-foreground tabular-nums lg:table-cell">
        <TimeAgo at={task.createdAt} />
      </TableCell>
    </TableRow>
  );
}
